import StageTest from './StageTest';

export default StageTest;
